import {httpInterceptor} from "./interceptor";
import {toast} from "react-toastify";

export async function getNeighborhoods(municipality) {
    try {
        if (municipality) {
            const response = await httpInterceptor.get(`neighborhoods/list?municipality=${municipality}`);
            if (response?.status === 200) {
                return response.data.data;
            } else if (response && response.success) {
                return response.data
            }
        }
    } catch (error) {
        toast('Error obteniendo barrios intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getResourceTypes() {
    try {
        const response = await httpInterceptor.get('resource-types/list');
        if (response?.status === 200) {
            return response.data.data;
        } else if (response && response.success) {
            return response.data
        }
    } catch (error) {
        toast('Error obteniendo data del servidor intente de nuevo', {
            type: 'error'
        });
    }
}

export async function getUsers() {
    try {
        const response = await httpInterceptor.get('users/list');
        if (response?.status === 200) {
            return response.data.data;
        } else if (response && response.success) {
            return response.data
        }
    } catch (error) {
        toast('Error obteniendo usuarios del servidor intente de nuevo', {
            type: 'error'
        });
    }
}

export async function getMunicipalities(zoneId) {
    try {
        const resource = zoneId ? `municipalities/list-zone?zone=${zoneId}` : 'municipalities/list';
        const response = await httpInterceptor.get(resource);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data
        }
        return data

    } catch (error) {
        toast('Error obteniendo data del servidor intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getZones() {
    try {
        const response = await httpInterceptor.get(`/zones/list`);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data;
        }
        return data;
    } catch (error) {
        toast('Error obteniendo datos intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getSchools(userId) {
    try {
        const resource = userId ? `schools/list?facilitator=${userId}` : 'schools/list';
        const response = await httpInterceptor.get(resource);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data;
        }
        return data;
    } catch (error) {
        toast('Error obteniendo escuelas intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getBeneficiary(documentNumber) {
    try {
        if (documentNumber) {
            const resource = `beneficiary?document=${documentNumber}`;
            const response = await httpInterceptor.get(resource);
            let data = []
            if (response?.status === 200) {
                data = response.data.data;
            } else if (response && response.success) {
                data = response.data;
            }
            return data;
        }
    } catch (error) {
        toast('Error obteniendo beneficiario intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getBeneficiaryById(id) {
    try {
        if (id) {
            const resource = `beneficiary?uid=${id}`;
            const response = await httpInterceptor.get(resource);
            let data = []
            if (response?.status === 200) {
                data = response.data.data;
            } else if (response && response.success) {
                data = response.data;
            }
            return data;
        }
    } catch (error) {
        toast('Error obteniendo beneficiario intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function addBeneficiary(groupId, beneficiaryId, schoolId) {
    try {
        const resource = `beneficiary/group`;
        const response = await httpInterceptor.put(resource,
            {group: groupId, beneficiary: beneficiaryId, school: schoolId});
        if (response?.status === 200) {
            return true
        } else if (response && response.success) {
            return true
        }

    } catch (error) {
        toast('Error asociando beneficiario intente de nuevo', {
            type: 'error'
        });
    }
    return false;
}

export async function unbindBeneficiary(beneficiaryId) {
    try {
        const resource = `beneficiary/unbind`;
        const response = await httpInterceptor.put(resource,
            {group: 0, beneficiaryId: beneficiaryId, school: 0});
        if (response?.status === 200) {
            return true
        } else if (response && response.success) {
            return true
        }

    } catch (error) {
        toast('Error asociando beneficiario intente de nuevo', {
            type: 'error'
        });
    }
    return false;
}

export async function getBeneficiaries(groupId, meetingId) {
    try {
        if (groupId || meetingId) {
            let resource = groupId ? `beneficiary/list-by-group?group=${groupId}` : 'beneficiary/list';
            if (meetingId) {
                resource = `beneficiary/list-by-meeting?meetingId=${meetingId}`;
            }
            const response = await httpInterceptor.get(resource);
            let data = []
            if (response?.status === 200) {
                data = response.data.data;
            } else if (response && response.success) {
                data = response.data;
            }
            return data;
        }
    } catch (error) {
        toast('Error obteniendo beneficiarios intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getAllBeneficiaries() {
    try {
        const resource = 'beneficiary/list';
        const response = await httpInterceptor.get(resource);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data;
        }
        return data;

    } catch (error) {
        toast('Error obteniendo beneficiarios intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getList(type) {
    try {
        const resource = `lists/by-type?type=${type}`;
        const response = await httpInterceptor.get(resource);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data;
        }
        return data;

    } catch (error) {
        toast('Error obteniendo lista intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getMeetings(year) {
    try {
        const resource = `meetings?year=${year}`;
        const response = await httpInterceptor.get(resource);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data;
        }
        return data;
    } catch (error) {
        toast('Error obteniendo encuentros intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getMeetingsByGroup(groupId) {
    try {
        const resource = `meetings/list-group?groupId=${groupId}`;
        const response = await httpInterceptor.get(resource);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data;
        }
        return data;
    } catch (error) {
        toast('Error obteniendo lista de encuenrtros,  intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getMeetingsAttendance(meetingId) {
    try {
        const resource = `meetings/attendance-list?meetingId=${meetingId}`;
        const response = await httpInterceptor.get(resource);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data;
        }
        return data;
    } catch (error) {
        toast('Error obteniendo lista de encuentros,  intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getAllAttendances() {
    try {
        const resource = `meetings/attendance-all`;
        const response = await httpInterceptor.get(resource);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data;
        }
        return data;
    } catch (error) {
        toast('Error obteniendo lista de encuentros,  intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function getAttendances(schoolId, groupId) {
    try {
        const resource = `meetings/attendance-list-group?schoolId=${schoolId}&groupId=${groupId}`;
        const response = await httpInterceptor.get(resource);
        let data = []
        if (response?.status === 200) {
            data = response.data.data;
        } else if (response && response.success) {
            data = response.data;
        }
        return data;
    } catch (error) {
        toast('Error obteniendo lista de encuentros,  intente de nuevo', {
            type: 'error'
        });
    }
    return null;
}

export async function saveMeetingGeneralInfo(meeting) {
    if (meeting) {
        try {
            const resource = `meetings`;
            const response = await httpInterceptor.post(resource, meeting);

            if (response?.status === 200) {
                return true
            } else if (response && response.success) {
                return true
            }

        } catch (error) {
            toast('Error guardando vigencia de encuentros intente de nuevo', {
                type: 'error'
            });
        }
        return false;
    }
}

export async function updateSchoolGroup(group) {
    if (group) {
        try {
            const resource = `schools/group`;
            const response = await httpInterceptor.put(resource, group);
            if (response?.status === 200) {
                return true
            } else if (response && response.success) {
                return true
            }
        } catch (error) {
            toast('Error actualizando grupo', {
                type: 'error'
            });
        }
        return false;
    }
}

export async function deleteSchoolGroup(groupId, schoolId) {
    if (groupId) {
        try {
            const resource = `schools/group`;
            const response = await httpInterceptor.delete(resource, {
                data: {
                    groupId,
                    schoolId
                }
            });
            if (response?.status === 200) {
                return true
            } else if (response && response.success) {
                return true
            }
        } catch (error) {
            toast('Error actualizando grupo', {
                type: 'error'
            });
        }
        return false;
    }
}

export async function saveMeetingAttendance(meeting) {
    if (meeting) {
        try {
            const resource = `meetings/attendance`;
            const formData = new FormData();
            meeting.images.forEach((image, index) => {
                formData.append(`image${index}`, image.imageUrl);
            })

            meeting.beneficiaries.forEach((b, index) => {
                formData.append(`beneficiary-id-img${b.id}`, b.image);
            })
            const response = await httpInterceptor.post(resource, meeting);
            if (response?.status === 200) {
                return true
            } else if (response && response.success) {
                return true
            }

        } catch (error) {
            console.error(error?.response);
            if (error?.response?.data?.message.indexOf('IMAGEN') !== -1) {
                toast(error?.response?.data?.message, {
                    type: 'error'
                });
            } else {
                toast('Error guardando asistencia', {
                    type: 'error'
                });
            }
        }
        return false;
    }
}

export async function deleteAttendance(attendanceId) {
    try {
        const resource = `meetings/delete-attendance-record?attendanceId=${attendanceId}`;
        const response = await httpInterceptor.delete(resource)
        if (response?.status === 200) {
            return true
        } else if (response && response.success) {
            return true
        }

    } catch (error) {
        toast('Error elilminando asistencia intente de nuevo', {
            type: 'error'
        });
    }
    return false;
}
export async function deleteImage(imageId) {
    try {
        const resource = `image?imageId=${imageId}`;
        const response = await httpInterceptor.delete(resource)
        if (response?.status === 200) {
            return true
        } else if (response && response.success) {
            return true
        }

    } catch (error) {
        toast('Error elilminando Imagen intente de nuevo', {
            type: 'error'
        });
    }
    return false;
}